import React, { Component } from 'react'
import {Paragraph} from './Paragraph'
import {Endorsement} from './Endorsement'

const renderParagraphs = function(paragraphs, styleMod) {
  let nParagraphs = paragraphs.length;
  let marginBottom = {marginBottom : 20};
  let last = {marginBottom : -2};

  let result = paragraphs.map(
    function(paragraphObj, index) {
      let style = index != nParagraphs - 1 ? marginBottom : last;
      return (
        <div key = {index} style = {style}>
          <Paragraph
            text={paragraphObj.text}
            style = {styleMod}
            containsHTML={paragraphObj.containsHTML}>
          </Paragraph>
        </div>
      );
    }
  );

  return result;
}

const renderVideos = function(videos) {
  let result = videos.map(
    function(video, index) {
      return (
        <div
          key={index}
          style={{
            marginBottom : video.src.includes("vimeo") ? -10 : 25,
            marginTop : video.src.includes("vimeo") ? -20 : index === 0 ? 10 : 50,}}
          className="iframe-container">
          <iframe
            src={video.src}
            frameBorder="0"
            allowFullScreen>
          </iframe>
        </div>
      );
    }
  );

  return result;
}

const renderEndorsements = function(endorsements) {
  let result = endorsements.map(
    function(endorsement, index) {
      let marginBottomStyle = index != endorsements.length - 1 ? {marginBottom : 35} : {};

      return (
        <div key={index} style={marginBottomStyle}>
          <Endorsement
            name = {endorsement.name}
            title = {endorsement.title}
            text = {endorsement.text}
            imgSrc = {endorsement.imgSrc}></Endorsement>
          </div>
      );
    }
  );

  return result;
}

export { renderParagraphs, renderVideos, renderEndorsements};



// WEBPACK FOOTER //
// ./src/components/utils.js